/**
 * @file 个人中心
 * @author wangzhuang
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Sidebar, Button, Table, Tag, Modal, Tips, Toast} from '@baidu/spui';
import {fetchGetList, fetchFeedbackDetail} from '../../actions/userCenterAction';
import {fetchDelete} from '../../actions/attestAction';
import MyAttestDetail from './myAttestDetail';
import {getUrlValue} from '../../util';
import {bCat_2055_request} from '../../util';
import MyAttestPaidList from './myAttestPaidList';
import './index.less';
export class userCenter extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            page: 1,
            size: 10,
            total: 10,
            selectedKeys: [],
            data: [],
            companyName: getUrlValue('companyName'),
            pageObj: {
                'my_attest': {
                    text: '我的认证',
                    type: 'auth',
                    btn: {
                        label: '认证号码',
                        value: 'btn',
                        onClick: () => {
                            window.open('/attest?pagef=userCenter');
                        }
                    }
                },
                'my_appeal': {
                    text: '我的申诉',
                    type: 'appeal',
                    btn: {
                        label: '申诉号码',
                        value: 'btn',
                        onClick: () => {
                            window.open('/appeal?pagef=userCenter');
                        }
                    }
                },
                'my_mark': {
                    text: '我的标记',
                    type: 'report',
                    btn: {
                        label: '标记号码',
                        value: 'btn',
                        onClick: () => {
                            window.open('/mark?pagef=userCenter');
                        }
                    }
                },
                'my_feedback': {
                    text: '我的反馈',
                    type: 'feedback',
                    btn: false
                },
            }
        };
    }

    componentDidMount() {
        const paramsType = this.props.match.params.type;
        this.getList(paramsType);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.type !== this.props.match.params.type) {
            this.setState({
                data: []
            }, () => {
                const paramsType = this.props.match.params.type;
                this.getList(paramsType);
            });

        }
    }

    getList = (type) => {
        let {pageObj, page, size} = this.state;

        const fetchGetList = (params) => this.props.fetchGetList(pageObj[type].type, {
            page: page,
            size: size,
            ...params
        }).then(data => {
            if (data.code === 200) {
                this.setState({
                    data: data.data.list,
                    total: data.data.total
                });
                // if (fetchPaidAttestListFlag) {
                //     this.getGetPaidAttestList();
                // }
            }
        });
        bCat_2055_request(fetchGetList);
    };
    // 付费认证有权限控制，暂定不走bCat_2055_request【临时注释】
    // getGetPaidAttestList = () => {
    //     const fetchGetPaidAttestList = params => {
    //         this.props
    //             .fetchGetPaidAttestList('auth', {
    //                 page: 1,
    //                 size: 10,
    //                 ...params
    //             });
    //     };
    //     bCat_2055_request(fetchGetPaidAttestList);
    // };

    handleMenuClick1(e) {
        this.props.history.push(e.key);
    }
    delHandle(id, ct) {
        Modal.confirm({
            title: '删除',
            buttonReverse: true,
            maskClosable: true,
            buttonType: 0,
            warningType: true,
            okText: '仍然删除',
            CancelText: '取消',
            className: 'spui-modal-other',
            children: <div>
                删除该认证信息，将导致数据无法在百度展示，请谨慎操作。
            </div>,
            onOk: () => {
                /* eslint-disable */
                this.props.fetchDelete({id: parseInt(id, 10), create_time: ct}).then(data => {
                    // console.log(data);
                    if (data.code === 200) {
                        this.getList(this.props.match.params.type)
                        //this.props.history.push('/user_center/my_attest');
                    } else {
                        Toast.display({
                            type: 'error',
                            info: data.message,
                            delay: 3500
                        });
                    }
                });
            },
        });
    }


    render() {
        let type = this.props.match.params.type;
        let {pageObj, data, page, size, total, companyName} = this.state;
        const treeDataSource = [
            {
                key: 'my_attest',
                content: '我的认证',
                iconImgObj: require('../../asset/img/userCenter/renzheng.svg')
            },
            {
                key: 'my_appeal',
                content: '我的申诉',
                iconImgObj: require('../../asset/img/userCenter/shensu.svg')
            },
            {
                key: 'my_mark',
                content: '我的标记',
                iconImgObj: require('../../asset/img/userCenter/biaoji.svg')
            },
            {
                key: 'my_feedback',
                content: '我的反馈',
                iconImgObj: require('../../asset/img/userCenter/fankui.svg')
            }
        ];

        let columnConfigs = [
            {
                refer: 'id',
                title: '认证ID',
                width: '100px'
            },
            {
                refer: 'company_name',
                title: '认证主体',
                width: '180px',
                render: (val, index, row) => {
                    return <span>
                        {val}
                        {
                            row.is_history
                            // val
                                ? <Tips title="该认证信息已在2021年3月底开启产品全面升级调整，建议您重新认证！"
                                    placement={'right'}>
                                    <img className="uptip" src={require('../../asset/img/upgrade/error.svg')} alt=""/>
                                </Tips>
                                : null
                        }
                    </span>;
                }
            },
            {
                refer: 'phone',
                title: '认证号码',
                width: '150px'
            },
            {
                refer: 'person_status',
                title: '审核状态',
                width: '110px',
                render: val => {
                    // red 未通过 2
                    // green 已通过 1
                    // blue 审核中 0
                    let obj = {
                        '0': {
                            color: 'blue',
                            title: '审核中'
                        },
                        '1': {
                            color: 'green',
                            title: '审核通过'
                        },
                        '2': {
                            color: 'red',
                            title: '审核失败'
                        },
                        '3': {
                            color: 'red',
                            title: '已过期'
                        }
                    };
                    return <Tag
                        title={obj[val].title}
                        type={'hollow'}
                        color={obj[val].color}
                    />;
                }
            },
            {
                refer: 'update_time',
                title: '更新时间',
                width: '125px',
                render: (val) => {
                    return val.split(' ')[0];
                }
            },
            {
                refer: 'expired_time',
                title: '过期时间',
                width: '125px',
                render: (val) => {
                    return val.split(' ')[0];
                }
            },
            {
                refer: 'd6',
                title: '操作',
                width: '180px',
                render: (val, index, data) => {
                    return <div className={'operate attestcz'}>
                        <div>
                            <a
                                href={`/info_attest/${data.id}/${data.create_time}`} className={'link'} target={'_blank'}
                                rel="noopener noreferrer">
                                查看详情
                            </a>
                        </div>

                        {/* {
                            data.person_status !== 0
                            && (<a className={'link'}
                                onClick={()=>{
                                    this.delHandle(data.id, data.create_time)
                                }
                                }
                            >
                                    删除
                            </a>)
                        } */}
                        {(data.person_status !== 0 && data.person_status !== 1)
                            && <a
                                href={`/info_attest/${data.id}/edit`} className={'link'}
                            >
                                修改信息
                            </a>
                        }
                    </div>;
                }
            }
        ];

        if (type === 'my_appeal') {
            columnConfigs = [
                {
                    refer: 'phone',
                    title: '申诉号码',
                    width: '225px'
                },
                {
                    refer: 'mode',
                    title: '申诉类型',
                    width: '185px',
                    render: val => {
                        let json = {
                            '2': '个人号码',
                            '1': '企业号码',
                            '3': '政府号码'
                        };

                        if (json[val]) {
                            return json[val];
                        } else {
                            return '-';
                        }
                    }
                },
                {
                    refer: 'person_status',
                    title: '审核状态',
                    width: '110px',
                    render: val => {
                        // red 未通过 2
                        // green 已通过 1
                        // blue 审核中 0
                        let obj = {
                            '0': {
                                color: 'blue',
                                title: '审核中'
                            },
                            '1': {
                                color: 'green',
                                title: '已通过'
                            },
                            '2': {
                                color: 'red',
                                title: '未通过'
                            },
                            '3': {
                                color: 'red',
                                title: '已过期'
                            }
                        };
                        return <Tag
                            title={obj[val].title}
                            type={'hollow'}
                            color={obj[val].color}
                        />;
                    }
                },
                {
                    refer: 'create_time',
                    title: '申诉时间',
                    width: '125px',
                    render: (val) => {
                        return val.split(' ')[0];
                    }
                },
                {
                    refer: 'update_time',
                    title: '更新时间',
                    width: '125px',
                    render: (val) => {
                        return val.split(' ')[0];
                    }
                },
                {
                    refer: 'd6',
                    title: '操作',
                    width: '222px',
                    render: (val, index, data) => {
                        return <div className={'operate'}>
                            <a
                                href={`/info_appeal/${data.id}/${data.create_time}`}
                                className={'link'}
                                target={'_blank'}
                                rel="noopener noreferrer"
                            >
                                查看详情
                            </a>
                            {/* {
                                data.person_status !== 0
                                    ? <a
                                        href={`/info_appeal/${data.id}/edit`}
                                        className={'link'}
                                        target={'_blank'}
                                        rel="noopener noreferrer"
                                    >
                                        重新提交
                                    </a>
                                    : <span className={'disable'}>重新提交</span>
                            } */}
                        </div>;
                    }
                }
            ];
        }

        if (type === 'my_mark') {
            columnConfigs = [
                {
                    refer: 'phone',
                    title: '标记号码'
                },
                {
                    refer: 'label',
                    title: '号码类型'
                },
                {
                    refer: 'create_time',
                    title: '标记时间',
                    render: (val) => {
                        return val.split(' ')[0];
                    }
                }
            ];
        }

        if (type === 'my_feedback') {
            columnConfigs = [
                {
                    refer: 'content',
                    title: '反馈内容',
                    width: '416px'
                },
                {
                    refer: 'create_time',
                    title: '提交时间',
                    render: (val) => {
                        return val.split(' ')[0];
                    }
                },
                {
                    refer: 'is_solve',
                    title: '审核状态',
                    width: '156px',
                    render: val => {
                        // 0 处理中
                        // 1 处理完成

                        let obj = {
                            '1': {
                                color: 'green',
                                title: '处理完成'
                            },
                            '0': {
                                color: 'blue',
                                title: '处理中'
                            }
                        };
                        return <Tag
                            title={obj[val].title}
                            type={'hollow'}
                            color={obj[val].color}
                        />;
                    }
                },
                {
                    refer: 'd6',
                    title: '操作',
                    width: '222px',
                    render: (val, index, data) => {
                        let src = `/api/v1/image/get?product_id=haoma&img_id=${data.img_id})`;
                        return <div className={'operate'}>
                            <span
                                className={'link'}
                                onClick={() => {
                                    let obj = {
                                        page: 1,
                                        size: 10,
                                        id: data.id
                                    };
                                    this.props.fetchFeedbackDetail(obj).then(data2 => {
                                        if (data2.code === 200) {
                                            Modal.confirm({
                                                title: '问题反馈详情',
                                                buttonReverse: true,
                                                buttonType: 0,
                                                singleButton: true,
                                                okText: '关闭',
                                                className: 'spui-modal-other',
                                                children: <div>
                                                    <div className={'uc-modal'}>
                                                        <div className={'left'}>
                                                            反馈内容:
                                                        </div>
                                                        <div className={'right'}>
                                                            <div>
                                                                {data.content}
                                                            </div>
                                                            {data.img_id
                                                                ? <img
                                                                    src={src}
                                                                    alt=""
                                                                />
                                                                : null
                                                            }

                                                        </div>
                                                    </div>
                                                    <div className={'uc-modal mt28'}>
                                                        <div className={'left'}>
                                                            处理结果:
                                                        </div>
                                                        <div className={'right'}>
                                                            {
                                                                data.is_solve === 0
                                                                    ? <span className={'fs_14_999'}>请耐心等待处理结果</span>
                                                                    : data2.data.list.message[0].content
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                            });
                                        }
                                    });
                                }}
                            >
                                查看详情
                            </span>
                        </div>;
                    }
                }
            ];
        }

        const pageConfigs = {
            skipFlag: true,
            current: page,
            perPage: size,
            totalItem: total || 10,
            onChange: data => {
                this.setState({
                    page: data.current,
                    size: data.perPage
                }, () => {
                    this.getList(type);
                });
            }
        };
        const isAliasMyAttest = window.location.href.indexOf('/user_center/my_attest?companyName=') > -1
        return (
            <div className={'userCenter'}>
                <div>
                    <Sidebar
                        selectedKeys={[type]}
                        onlyIcon={false}
                        theme="dark"
                        onHandleClick={this.handleMenuClick1.bind(this)}
                        dataSource={treeDataSource}
                    />
                </div>
                <div className={'main'}>
                    {isAliasMyAttest
                        ? <MyAttestDetail company={companyName} />
                        : <>
                        <div className={'top'}>
                            <div className={'title'}>{pageObj[type] ? pageObj[type].text : ''}</div>
                            {
                                pageObj[type] && pageObj[type].btn
                                    ? <Button {...pageObj[type].btn} />
                                    : null
                            }

                        </div>
                        <div className={'con'}>
                            <Table
                                data={data}
                                columnConfigs={columnConfigs}
                                pager={pageConfigs}
                            />
                        </div>
                        {type === 'my_attest' && <MyAttestPaidList {...this.props}></MyAttestPaidList>}
                    </>}
                </div>
            </div>
        );
    }
}

userCenter.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    fetchGetList: PropTypes.func,
    fetchFeedbackDetail: PropTypes.func,
    fetchDelete: PropTypes.func,
    // fetchGetPaidAttestList: PropTypes.func,
};


function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchGetList: (type, obj) => fetchGetList(dispatch, type, obj),
        fetchFeedbackDetail: obj => fetchFeedbackDetail(dispatch, obj),
        fetchDelete: obj => fetchDelete(dispatch, obj),
        // fetchGetPaidAttestList: (type, obj) => fetchGetPaidAttestList(dispatch, type, obj),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(userCenter));